module.exports = __webpack_public_path__ + "static/img/jkrs-xq.7edb391.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/jkrs-xq.png
// module id = V8oO
// module chunks = 0